import React, { useCallback } from 'react';
import { ColumnDataType, FavouriteDataColumn }
  from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import { DisplayDateValue, DisplayResultValue } from 'app/area/case-report/case-table-view/components/case-table-view-cells';
import { CASE_TABLE_VIEW_DATE_FORMAT } from 'app/area/case-report/case-table-view/components/case-table-view-util';
import { ComplexValue, Entity, StoreData } from 'app/types-shared';
import { TranslationType } from 'app/area/case-report/case-table-view/case-table-view-container';
import { getCaseIdField } from 'app/area/case-report/case-table-view/components/case-table-view-rows';
import { CaseTableViewMeatballMenu } from 'app/area/case-report/case-table-view/components/case-table-view-meatball-menu';
import { AddRiskEvaluationInitialValues } from 'app/area/case/features/loss-potential-evaluation/types';

interface CardProps {
  row: Entity[];
  columns: Partial<FavouriteDataColumn>[];
  locale: string;
  index: number;
  translation: TranslationType;
  onDeleteCase: (caseId: number) => void;
  onCopyRiskEvaluation: (caseId: number, riskMatrixInstance: number, instanceCopyCmd: number, 
    initialValues: AddRiskEvaluationInitialValues, copyToResidual: boolean) => void;
    tableViewRef?: React.RefObject<HTMLDivElement>;
}

const Card: React.FC<CardProps> = React.memo(({ row, columns, locale, index, translation, onDeleteCase, 
  onCopyRiskEvaluation, tableViewRef }: CardProps) => {
    const renderRow = useCallback(() => {
      return columns.map((column, columnIndex) => {
        const fields = row?.[0];
        const itemTd = fields?.[column.columnName] as ComplexValue<number>[];
        return (
          <tr key={`tr-${index}-${columnIndex}`}>
            <th>{column.shortText}</th>
            <td>
              {columnIndex === 0 && <div data-ref={columnIndex}>
                <CaseTableViewMeatballMenu caseId={getCaseIdField(row)} translation={translation} onDeleteCase={onDeleteCase} 
                  onCopyRiskEvaluation={onCopyRiskEvaluation} tableViewRef={tableViewRef}/>
              </div>}
              {column.dataType === ColumnDataType.Date ?
                <DisplayDateValue
                  cells={itemTd}
                  componentId={`data-column-${index}-${columnIndex}`}
                  dateTimeFormatter={CASE_TABLE_VIEW_DATE_FORMAT}
                  locale={locale}
                  column={column}
                  key={`${index}-${columnIndex}`}
                  isMobielView={true}
                />
                : <DisplayResultValue
                  cells={itemTd}
                  column={column}
                  componentId={`data-column-${index}-${columnIndex}`}
                  key={`${index}-${columnIndex}`}
                  isMobielView={true}
                />
              }
            </td>
          </tr>
        );
      }
    );
    }, [row, columns, locale]);

    return (
      <tbody>
        {renderRow()}
      </tbody>
    );
});

export function CaseTableMobileView({ rows, columns, locale, translation, onDeleteCase, onCopyRiskEvaluation, tableViewRef }:
  {
    rows: StoreData[];
    columns: Partial<FavouriteDataColumn>[];
    locale: string;
    translation: TranslationType;
    onDeleteCase: (caseId: number) => void;
    onCopyRiskEvaluation: (caseId: number, riskMatrixInstance: number, instanceCopyCmd: number, 
      initialValues: AddRiskEvaluationInitialValues, copyToResidual: boolean) => void;
      tableViewRef?: React.RefObject<HTMLDivElement>;
  }) {

  if (!rows?.length) {
    return null;
  }

  return (
    <table className="case-table-mobile-view">
      {rows.map((row, rowIndex) => (
        <Card key={rowIndex} row={row} columns={columns} locale={locale} index={rowIndex} translation={translation} 
          onDeleteCase={onDeleteCase} onCopyRiskEvaluation={onCopyRiskEvaluation} tableViewRef={tableViewRef} />
      ))}
    </table>
  );
}
